import React, { useEffect, useContext, useState } from "react";
import styles from "./Game.module.sass";
import Hero from "./Hero";
import { useParams, withRouter } from 'react-router-dom';
import { ConquerContext } from "../../contexts/ConquerContext";
import GameChat from "./GameChat";
import { GameContext } from "../../contexts/GamesContext";

const Game = ({history}) => {

    const {show, hide} = useContext( GameContext );
    const conquer = useContext( ConquerContext );
    const { gameKey } = useParams();
    // const [ gameData, setGameData ] = useState();

    const LoadGame = async function(){

        let response = await conquer.Games.getData( gameKey );
        console.log( 'LOAD GAME RESPONSE:', response );
        // setGameData( response );
        if( !response ) return goBackToHome(); 
        
        show( {gameKey, onCloseCallback: goBackToHome, clear: true} );

    };
    useEffect( () => { LoadGame() }, [] )

    function goBackToHome(){
        console.log('BACK TO HOME FROM GAME');
        history.push('/')
    }

    return <></>;

    // return (
    //     <div className={styles.container}>
    //         <Hero game={gameData}/>
    //         <GameChat gameKey={gameKey}/>
    //     </div>
    // );
};

export default withRouter(Game);
